import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getEnrollInfo, startEnroll } from "../../services/assessmentCalls";
import s from "./Enroll.module.css";
import { poweredByUrl } from "./poweredBy";
import { displayRole } from "../PartnerPortal/partnerRoleCatalog";
// (uses the partner API host via assessmentCalls)

/* Shared enrollment link landing (/enroll/:token). Candidate enters their
   details → we mint their session → hand off to /assessment/:sessionId. */

const NAVY = "#0d1b3e";

export default function Enroll() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [form, setForm] = useState({ firstName: "", lastName: "", email: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getEnrollInfo(token)
      .then((res) => setInfo(res?.data || res))
      .catch((e) => setError(e?.response?.data?.message || e?.response?.data?.errors || "This link is invalid or has expired."));
  }, [token]);

  const start = async (e) => {
    e.preventDefault();
    setError("");
    const details = { firstName: form.firstName.trim(), lastName: form.lastName.trim(), email: form.email.trim() };
    if (!details.firstName || !details.email.includes("@")) return setError("Enter your name and a valid email.");
    setBusy(true);
    try {
      const res = await startEnroll(token, details);
      const sessionId = (res?.data || res)?.sessionId;
      if (sessionId) navigate(`/assessment/${sessionId}`);
      else setError("Could not start the assessment.");
    } catch (err) {
      setError(err?.response?.data?.message || err?.response?.data?.errors || "Could not start the assessment.");
    } finally {
      setBusy(false);
    }
  };

  const brand = info?.brand || { name: "Assessment", brandColor: NAVY };

  return (
    <div className={s.shell}>
      <div className={s.card}>
        <div className={s.brandRow}>
          <div className={s.brandMark} style={{ background: brand.brandColor || NAVY }}>
            {brand.logoUrl ? <img src={brand.logoUrl} alt="" className={s.logoImg} /> : (brand.name || "A").slice(0, 2).toUpperCase()}
          </div>
          <div className={s.brandName}>{brand.name}</div>
        </div>

        {error && <div className={s.err}>{error}</div>}

        {info && !info.open && info.closedReason !== "full" ? (
          <div className={s.closed}>
            {info.closedReason === "expired" ? "This assessment link has expired." : "This assessment link is closed."}{" "}
            Please contact {brand.name} for a new invitation.
          </div>
        ) : info ? (
          <form onSubmit={start}>
            <h1 className={s.title}>{brand.name} — {displayRole(info.role)} assessment</h1>
            {info.open ? (
              <p className={s.lead}>Enter your details to begin. Takes about 20 minutes — there are no trick answers.</p>
            ) : (
              <p className={s.lead}>
                This link has reached its limit of candidates. If you've already started this assessment, enter the same
                email to continue; otherwise contact {brand.name} for a new invitation.
              </p>
            )}
            <div className={s.nameGrid}>
              <input className={s.inp} placeholder="First name" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} />
              <input className={s.inp} placeholder="Last name" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} />
            </div>
            <input className={`${s.inp} ${s.mb16}`} placeholder="you@email.com" autoComplete="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            <button type="submit" disabled={busy} className={s.btn}>
              {busy ? "Starting…" : info.open ? "Start assessment →" : "Continue my assessment →"}
            </button>
          </form>
        ) : (
          !error && <p className={s.loading}>Loading…</p>
        )}
        <div className={s.powered}>
          <a className={s.poweredLink} href={poweredByUrl("enroll", info?.brand?.name)} target="_blank" rel="noopener noreferrer">
            Powered by <b className={s.poweredBrand}>AwaSource</b>
          </a>
        </div>
      </div>
    </div>
  );
}
